import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CalculoAlmacenaje from './CalculoAlmacenaje.jsx'; 
import CalculoMuellaje from './CalculoMuellaje.jsx'; 
import Acordion from '../components/Acordion.jsx';
import Modal from '../components/Modal.jsx'; 
import '../styles/Calculo.css'; 
import '../styles/Acordion.css'; 

const Calculo = () => {
  // Hook para acceder al estado pasado desde Cotizar.jsx
  const location = useLocation();

  const [showModal, setShowModal] = useState(false);

  // Estados para acumular los costos
  const [datosTransporte, setDatosTransporte] = useState(null);
  const [costoAlmacenaje, setCostoAlmacenaje] = useState(0);
  const [costoMuellaje, setCostoMuellaje] = useState(0);

  // Cargar datos de transporte si existen y mostrar modal de bienvenida
  useEffect(() => {
    if (location.state && location.state.transporte) {
      setDatosTransporte(location.state.transporte);
    }
    setShowModal(true);
  }, [location]);

  const handleClose = () => {
    setShowModal(false);
  };

  // Callbacks para que los componentes hijos actualicen el total
  const handleAlmacenajeChange = (precio) => {
    const valor = Number(precio);
    setCostoAlmacenaje(Number.isNaN(valor) ? 0 : valor);
  };

  const handleMuellajeChange = (precio) => {
    const valor = Number(precio);
    setCostoMuellaje(Number.isNaN(valor) ? 0 : valor);
  };

  // Cálculo del Gran Total
  const costoTransporte = datosTransporte ? (Number(datosTransporte.total) || 0) : 0;
  const granTotal = costoTransporte + costoAlmacenaje + costoMuellaje;

  const formatMoney = (amount) => {
    return amount.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' });
  };

  return (
    <div className="accordion-container">
      
      {/* SECCIÓN DE RESUMEN DE COSTOS ACUMULADOS */}
      <div style={{ 
        backgroundColor: '#fff', 
        padding: '20px', 
        borderRadius: '8px', 
        boxShadow: '0 2px 5px rgba(0,0,0,0.1)', 
        marginBottom: '20px',
        borderLeft: '5px solid #003366',
        display: 'flex',
        flexDirection: 'column',
        gap: '15px'
      }}>
        <h2 style={{ margin: '0', color: '#003366', fontSize: '1.4rem' }}>Resumen de Cotización</h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '15px' }}>
          
          {/* Tarjeta de Transporte */}
          <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '6px', border: '1px solid #e9ecef' }}>
            <strong style={{ display: 'block', color: '#555', marginBottom: '5px' }}>
              Transporte {datosTransporte ? `(${datosTransporte.tipo})` : ''}
            </strong>
            <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#333' }}>
              {formatMoney(costoTransporte)}
            </span>
            {datosTransporte ? (
               <div style={{ fontSize: '0.8rem', color: '#666', marginTop: '5px' }}>
                 {datosTransporte.origen && datosTransporte.destino 
                    ? `${datosTransporte.origen} ➝ ${datosTransporte.destino}` 
                    : 'Ruta seleccionada'}
               </div>
            ) : (
               <div style={{ fontSize: '0.8rem', color: '#999', marginTop: '5px', fontStyle: 'italic' }}>
                 No se seleccionó ruta desde el mapa.
               </div>
            )}
          </div>

          {/* Tarjeta de Almacenaje */}
          <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '6px', border: '1px solid #e9ecef' }}>
            <strong style={{ display: 'block', color: '#555', marginBottom: '5px' }}>Almacenaje</strong>
            <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: costoAlmacenaje > 0 ? '#2E7D32' : '#999' }}>
              {formatMoney(costoAlmacenaje)}
            </span>
            {costoAlmacenaje > 0 && <div style={{ fontSize: '0.8rem', color: '#2E7D32', marginTop: '5px' }}>✓ Calculado</div>}
          </div>

          {/* Tarjeta de Muellaje */}
          <div style={{ background: '#f8f9fa', padding: '15px', borderRadius: '6px', border: '1px solid #e9ecef' }}>
            <strong style={{ display: 'block', color: '#555', marginBottom: '5px' }}>Muellaje</strong>
            <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: costoMuellaje > 0 ? '#2E7D32' : '#999' }}>
              {formatMoney(costoMuellaje)}
            </span>
            {costoMuellaje > 0 && <div style={{ fontSize: '0.8rem', color: '#2E7D32', marginTop: '5px' }}>✓ Calculado</div>}
          </div>

          {/* Tarjeta de Gran Total */}
          <div style={{ background: '#003366', color: 'white', padding: '15px', borderRadius: '6px', display:'flex', flexDirection:'column', justifyContent:'center' }}>
            <strong style={{ display: 'block', opacity: 0.9, marginBottom: '5px' }}>Gran Total Estimado</strong>
            <span style={{ fontSize: '1.5rem', fontWeight: 'bold' }}>{formatMoney(granTotal)}</span>
          </div>

        </div>
      </div>
      
      {/* Modal con la Guía de Cotización */}
      <Modal isOpen={showModal} onClose={handleClose}>
        <div style={{ padding: '10px' }}>
          <h2 style={{ 
            color: '#003366', 
            marginBottom: '15px', 
            textAlign: 'center',
            fontSize: '1.5rem'
          }}>
            Guía de Cotización de Servicios
          </h2>
          
          <p style={{ marginBottom: '15px', color: '#333' }}>
            Para completar su presupuesto, utilice los siguientes formularios. Los costos se sumarán automáticamente al total.
          </p>

          <ul style={{ paddingLeft: '20px', marginBottom: '20px', color: '#555', lineHeight: '1.6' }}>
            <li style={{ marginBottom: '10px' }}>
              <strong>Almacenaje:</strong> Si necesita guardar inventario por un período determinado.
            </li>
            <li>
              <strong>Muellaje:</strong> Costo por uso de infraestructura portuaria para carga/descarga.
            </li>
          </ul>

          <div style={{ textAlign: 'center' }}>
            <button 
              onClick={handleClose}
              style={{
                backgroundColor: '#003366',
                color: 'white',
                border: 'none',
                padding: '10px 30px',
                borderRadius: '5px',
                fontSize: '16px',
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              Entendido
            </button>
          </div>
        </div>
      </Modal>

      <Acordion>
        {/* Se pasan las funciones callback a los componentes hijos */}
        <CalculoAlmacenaje onCalculoTerminado={handleAlmacenajeChange} />
        <CalculoMuellaje onCalculoTerminado={handleMuellajeChange} />
      </Acordion>
    </div>
  );
};

export default Calculo;